export default __webpack_public_path__ + "static/CAMPUS-a4573714ff9c3fd561eb0a283cbee20f.png";